<template>
  <div class="about">
    <h1>The site for events to better world.</h1>
  </div>
</template>
